/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SigfoxDeviceCheckRecord from './SigfoxDeviceCheckRecord';

/**
* The CreateSigfoxDeviceErrorResponse model module.
* @module model/CreateSigfoxDeviceErrorResponse
* @version 2020-12-7
*/
export default class CreateSigfoxDeviceErrorResponse {
    /**
    * Constructs a new <code>CreateSigfoxDeviceErrorResponse</code>.
    * Sigfoxのデバイス登録失敗レスポンス
    * @alias module:model/CreateSigfoxDeviceErrorResponse
    * @class
    * @param result {module:model/CreateSigfoxDeviceErrorResponse.ResultEnum} 結果
    * @param status {Number} HTTPステータスコード
    * @param code {String} エラーコード
    * @param errorTitle {String} エラータイトル
    * @param errorMessage {String} エラーメッセージ
    */

    constructor(result, status, code, errorTitle, errorMessage) {
        
        
        this['result'] = result;
        this['status'] = status;
        this['code'] = code;
        this['errorTitle'] = errorTitle;
        this['errorMessage'] = errorMessage;
        
    }

    /**
    * Constructs a <code>CreateSigfoxDeviceErrorResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CreateSigfoxDeviceErrorResponse} obj Optional instance to populate.
    * @return {module:model/CreateSigfoxDeviceErrorResponse} The populated <code>CreateSigfoxDeviceErrorResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateSigfoxDeviceErrorResponse();
                        
            
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('errorTitle')) {
                obj['errorTitle'] = ApiClient.convertToType(data['errorTitle'], 'String');
            }
            if (data.hasOwnProperty('errorMessage')) {
                obj['errorMessage'] = ApiClient.convertToType(data['errorMessage'], 'String');
            }
            if (data.hasOwnProperty('record')) {
                obj['record'] = SigfoxDeviceCheckRecord.constructFromObject(data['record']);
            }
        }
        return obj;
    }

    /**
    * 結果
    * @member {module:model/CreateSigfoxDeviceErrorResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * HTTPステータスコード
    * @member {Number} status
    */
    'status' = undefined;
    /**
    * エラーコード
    * @member {String} code
    */
    'code' = undefined;
    /**
    * エラータイトル
    * @member {String} errorTitle
    */
    'errorTitle' = undefined;
    /**
    * エラーメッセージ
    * @member {String} errorMessage
    */
    'errorMessage' = undefined;
    /**
    * @member {module:model/SigfoxDeviceCheckRecord} record
    */
    'record' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG"    };

}
